import Icon from './Icon';

const KeyboardArrowUp = (props) => (
  <Icon
    {...props}
    path="M59.8 52.033c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-18.234-18.234-18.233 18.233c-0.445 0.416-1.045 0.671-1.704 0.671-1.381 0-2.5-1.119-2.5-2.5 0-0.659 0.255-1.259 0.672-1.706l-0.001 0.001 20-20c0.452-0.452 1.077-0.731 1.767-0.731s1.314 0.279 1.767 0.731v0l20 20c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
  />
);

export default KeyboardArrowUp;
